import { __decorate } from "tslib";
import { AccessGuard, accessGuardData, provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { UserRole } from '@core/shared/access';
import { ClassName } from '@core/shared/class-name';
import { CoreManagementComponent } from './management/management.component';
import * as i0 from "@angular/core";
let CoreFrontendManagementFeature = /*#__PURE__*/(() => {
  let CoreFrontendManagementFeature = class CoreFrontendManagementFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@core/frontend-management","featureId":"common-core"};
    }
    getFeatureFunctionality(functionality) {}
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵCoreFrontendManagementFeature_BaseFactory;
        return function CoreFrontendManagementFeature_Factory(__ngFactoryType__) {
          return (ɵCoreFrontendManagementFeature_BaseFactory || (ɵCoreFrontendManagementFeature_BaseFactory = i0.ɵɵgetInheritedFactory(CoreFrontendManagementFeature)))(__ngFactoryType__ || CoreFrontendManagementFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: CoreFrontendManagementFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'management',
          defineAddonSlot: 'management',
          component: CoreManagementComponent,
          children: [],
          canActivate: [AccessGuard],
          data: {
            pageTitle: 'Verwaltung',
            ...accessGuardData({
              allow: [UserRole.MANAGER]
            })
          }
        }, {
          path: 'manager',
          redirectTo: 'management'
        }])
        // provideFeatureAddonRoutes([])
        ]
      });
    }
  };
  CoreFrontendManagementFeature = __decorate([ClassName("CoreFrontendManagementFeature")], CoreFrontendManagementFeature);
  return CoreFrontendManagementFeature;
})();
export { CoreFrontendManagementFeature };